import EnumLiteralDoesNotExistError from "../error/EnumLiteralDoesNotExistError";

enum PageOverlayType {
    ABOUT_ME = "ABOUT_ME",
    INTERNSHIP = "INTERNSHIP",
    PROJECTS = "PROJECTS"
}

export const from = (literal: string): PageOverlayType => {
    const uppercaseLiteral = literal.toUpperCase();

    if (!Object.keys(PageOverlayType).includes(uppercaseLiteral))
        throw new EnumLiteralDoesNotExistError(literal, "PageOverlayType");

    return uppercaseLiteral as PageOverlayType;
};

export default PageOverlayType;
